import { transition, animate, style, query, stagger, keyframes, trigger } from '@angular/animations';

export const CardGridAnimationFade = transition('* <=> *', [
  // Initially the all cards are not visible
  query('.card--anim:enter', style({ opacity: 1, transform: 'translateY(10%)' }), { optional: true }),

  // Each card will appear sequentially with the delay of 300ms
  query(
    '.card--anim:enter',
    stagger('200ms', [
      animate(
        '200ms cubic-bezier(.49,.44,.76,1.07)',
        keyframes([style({ opacity: 1, transform: 'translateY(10%)' }), style({ opacity: 1, transform: 'translateY(0%)' })])
      ),
    ]),
    { optional: true }
  ),

  // Cards will disappear sequentially with the delay of 300ms
  // query(
  //   ':leave',
  //   stagger('50ms', [animate('250ms cubic-bezier(.49,.44,.76,1.07)', keyframes([style({ opacity: 1 }), style({ opacity: 0 })]))]),
  //   { optional: true }
  // ),
]);

export const CardGridAnimation = transition('* <=> *', [
  query('.card--anim:enter', style({ opacity: 0, transform: 'translateY(10%)' }), { optional: true }),
  query(
    '.card--anim:enter',
    stagger('100ms', [
      animate(
        '200ms cubic-bezier(0, 0, 0.2, 0.99)',
        keyframes([style({ opacity: 0, transform: 'translateY(10%)' }), style({ opacity: 1, transform: 'translateY(0%)' })])
      ),
    ]),
    { optional: true }
  ),
]);

export const CardGridAnimationOverview = transition('* <=> *', [
  query(
    ':enter',
    [
      style({ opacity: 0, transform: 'translateY(10%)' }),
      stagger('100ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0%)' }))),
    ],
    { optional: true }
  ),
  query(':leave', animate('100ms', style({ opacity: 0, transform: 'translateY(10%)' })), { optional: true }),
]);
